/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_New_Statement_TreeInputs */

const en_page_title_new_statement_tree = /** @type {(inputs: Page_Title_New_Statement_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New statement tree`)
};

const nl_page_title_new_statement_tree = /** @type {(inputs: Page_Title_New_Statement_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe jaarrekeningstructuur`)
};

/**
* | output |
* | --- |
* | "New statement tree" |
*
* @param {Page_Title_New_Statement_TreeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_new_statement_tree = /** @type {((inputs?: Page_Title_New_Statement_TreeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_New_Statement_TreeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_new_statement_tree(inputs)
	return en_page_title_new_statement_tree(inputs)
});